function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "landing-shoe",
  transform: "translate(-74.951 242.479) rotate(-20)"
}, React.createElement("path", {
  id: "bottom",
  d: "M13.483,0c-23.61,17.3-12.656,53.126,5.7,70.756s122.834,52.767,144.29,58.4,147.059,24.9,246.766,20.189,133.181-7.656,267.937-5.006,175.2-33.172,178.037-44.265-1.988-29.386-14.046-51.519c-1.929-3.541-11.393-25.677-11.393-25.677L596.076,30.905s-61.764,9.971-132.893,22.123S364.047,77.579,311.56,79.513,186.2,82.719,155.261,75.18,89.122,68.418,60.58,56.609,26.177,46.44,15.53,36.045,13.483,0,13.483,0Z",
  transform: "translate(0 242.852)",
  fill: "#b2b2b2",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("path", {
  id: "text-space",
  d: "M245.823,26.917c4.68,3.746-216.064,7.1-225.726,6.637S-1.7,11.578.2,9.8,233.709,0,233.709,0,241.143,23.171,245.823,26.917Z",
  transform: "translate(597.149 265.242)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("path", {
  id: "top-space",
  d: "M256.627,206.93s5,45.767-9.045,37.439-41.223-23.512-65.061-18.5-69.27,10.06-83.627,9.232S0,226.278,0,226.278s97.629-10.543,127.33-19.349,65.9-25.059,82.986-35.07,97.692-70.745,122.3-83.945S468.722-18.534,475.81,3.3s-10.163,53.2-6.87,71.228-4.647,22.681-4.647,22.681-51.317-21.269-74.164-9.291S287.191,136.2,236.094,164.32s-5.912,42.61-5.912,42.61Z",
  transform: "translate(79.997)",
  fill: "#ededed",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("path", {
  id: "middle-space",
  d: "M63.745,0s-8.57,40.341,51.373,46.127S236.146,71.535,249.29,95.743s33.879,41.188,33.879,41.188L175.853,152.79s-.076-23.225,8.5-27.759,18.992-12.307,17.665-19.388-18.28-13.756-24.877-14.969-50.835-11.8-50.835-11.8-25.24-8.527-44.608-11.05-52.24-2.218-63.5-4.742S-5.667,43.658,2.734,37.451,63.745,0,63.745,0Z",
  transform: "translate(287.302 143.153)",
  fill: "#EDEDED",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("path", {
  id: "bottom-space",
  d: "M212.449,0S4.544,86.067,2.153,93.91s-4.23,18.213,2.7,19.651,231.1-8.955,231.1-8.955-1.543-9.372-1.645-25.7.345-16.363-.911-24.02S212.449,0,212.449,0Z",
  transform: "translate(595.57 160.243)",
  fill: "#ddd",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("path", {
  id: "back-space",
  d: "M436.353.011c-3.125.687-28.409,12.683-49.946,31.094s-43.525,31.822-61.752,35.283-52.848-1.688-60.691-5.861-61.89-24.448-71.382-27.284S122.7,12.875,90.81,20.813.321,65.766.321,65.766s-7.66,40.592,51.813,46.821,113.158,26.133,123.495,36.278,23.387,33.421,26.932,36.716,16.559,17.393,16.559,17.393l27.767-5.523s-2.975-10.309,0-18.869S458.1,82.571,458.1,82.571s-9.855-22.979-12.19-37.206S439.478-.676,436.353.011Z",
  transform: "translate(350.302 77.338)",
  fill: "#FFFFFF",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("path", {
  id: "logo",
  d: "M27.111,8.062C26.58,3.468-9.858,44.2,2.59,74.6c8.783,20.01,35.564,20.21,89.167-5.341C230.984,2.892,229.209,4.531,228.117.278s-139,41.7-174.669,47.436S27.642,12.655,27.111,8.062Z",
  transform: "translate(538.297 152.053)",
  fill: "#3599F3"
}), React.createElement("path", {
  id: "front-space",
  d: "M73.5,17.46S15.779,24.367,7.614,33.495-16.464,78.017,52.177,93.623s229.045,36.9,312.96,16.257,92.473-22.54,92.473-22.54-.774-24.213,10.933-28.019,26.828-24.89-4.369-33.07S379.2,4.242,365.432,2.787,328.846,0,328.846,0s8.107,49.311-12.744,32.994-45.942-18.985-61.409-15.721-83.383,11.981-99.174,7.707S73.5,17.46,73.5,17.46Z",
  transform: "translate(6.838 208.68)",
  fill: "#61CCC1",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("path", {
  id: "top-border",
  d: "M0,35.355S33.232,18.486,52.015,21.4s49.328,10.563,55.152,13.955,60.574,26.253,69.99,27.213,35.205,10.253,55.246,3.724,33.54-19.957,45.952-29.243S313.161,11.11,313.161,11.11s30.682-19.319,32.7-7.007-6.631,12.92-6.631,12.92l-24.093,13.5s-34.978,27.94-44.833,33.985-46.62,29.406-93.15,12.105S70.639,32.741,0,35.355Z",
  transform: "translate(440.925 62.941)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("g", {
  id: "nike-text",
  transform: "translate(631.669 277.99)"
}, React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M.2,10.04S-1.326-.185,4.1,0,7.976,10.04,7.976,10.04",
  transform: "translate(0 3.214)",
  fill: "none",
  stroke: "#3599F3",
  strokeLinecap: "round",
  strokeWidth: 3
}), React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M0,9.453V0",
  transform: "translate(12.533 3.801)",
  fill: "none",
  stroke: "#3599F3",
  strokeLinecap: "round",
  strokeWidth: 3
}), React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M0,0V13.156",
  transform: "translate(16.422)",
  fill: "none",
  stroke: "#3599F3",
  strokeLinecap: "round",
  strokeWidth: 3
}), React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M5.168,0,0,4.657l5.945,5.419",
  transform: "translate(17.205 3.214)",
  fill: "none",
  stroke: "#3599F3",
  strokeLinecap: "round",
  strokeWidth: 3
}), React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M.257,4.18S8.8,5.429,8.117,2.322.968-.763.257,2.322s-.483,7.992,7.859,6.485",
  transform: "translate(25.084 3.75)",
  fill: "none",
  stroke: "#3599F3",
  strokeLinecap: "round",
  strokeWidth: 3
})), React.createElement("path", {
  id: "back-lace",
  d: "M2.931,35.528S-6.482,1.5,8.43.1,30.2,11.273,25.611,41.643s-2.041,77.194-2.041,77.194-2.146-33.825-1.93-44.75,1.93-48.3,1.93-48.3S24.239.831,10.133,3.421,2.931,35.528,2.931,35.528Z",
  transform: "translate(784.163 37.89)",
  fill: "#707070",
  stroke: "#707070",
  strokeWidth: 1
}));

var SvgLandingShoe = function SvgLandingShoe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 865.48,
    height: 612.398,
    viewBox: "0 0 865.48 612.398",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLandingShoe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/landing-shoe.55cdf8bf.svg";
export { ForwardRef as ReactComponent };